import {
    Carousel,
    CarouselContent,
    CarouselItem,
    type CarouselApi
} from '@/components/common/Carousel';
import { useEffect, useState } from 'react';
import { Button } from '@/components/common/Button';

interface BannerProps {
    bannerImages: string[]
}

export default function Banner({ bannerImages }: BannerProps) {
    const [api, setApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        if (!api) {
            return;
        }

        setCurrent(api.selectedScrollSnap() + 1);

        api.on('select', () => {
            setCurrent(api.selectedScrollSnap() + 1);
        });
    }, [api]);

    return (
        <div className='w-full relative'>
            <Carousel setApi={setApi} className='w-full' opts={{ loop: true }}>
                <CarouselContent>
                    {bannerImages.map((item, index) => (
                        <CarouselItem key={index}>
                            <div className='xl:h-[43.75rem] md:h-[31rem] h-[19.5rem] w-full overflow-hidden flex justify-center items-center'>
                                <img className='w-full h-full object-cover' src={item} alt='banner' />
                            </div>
                        </CarouselItem>
                    ))}
                </CarouselContent>
            </Carousel>
            <div className='absolute bottom-2 left-0 right-0 flex gap-5 justify-center'>
                {Array.from({ length: bannerImages.length }).map((_, index) => (
                    <Button
                        key={index}
                        onClick={() => api?.scrollTo(index)}
                        className={
                            `relative h-7 aspect-square rounded-full bg-transparent hover:bg-transparent ${current === (index + 1) ? 'border border-red-3' : 'border-0 border-transparent'}`
                        }
                    >
                        <span className={`absolute aspect-square w-4 rounded-full ${current === (index + 1) ? 'bg-red-3' : 'bg-white'}`}></span>
                    </Button>
                ))}
            </div>
        </div>
    );
}
